var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v242.667h242.667V0H0zm154.969 117.424H129.07v86.493h-28.342v-86.493H81.833V98.041h19.058V67.08c0-15.646 12.684-28.33 28.33-28.33h27.377v24.596h-19.722c-4.311 0-7.806 3.495-7.806 7.806v26.889h31.763l-5.864 19.383z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 242.667 242.667"};

module.exports = Facebook;

Facebook.default = Facebook;
